<!-- Bar Haute : info convive + actions -->
<div
  class="border-t border-b border-gris-3 flex items-center justify-between p-5 h-[88px] shrink-0"
>
  <!-- Bouton Retour -->
  <button
    type="button"
    (click)="goBack()"
    class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
  >
    <app-svg
      class="fg-gris-1 shrink-0"
      height="20"
      svgPath="assets/svg/arrow-back.svg"
      width="20"
    />
    {{ 'common.back' | translate }}
  </button>

  <!-- Infos convive -->
  <div class="flex items-center gap-5">
    @if (currentMealPlan()) {
      <div class="flex flex-col items-start">
        <span class="fg-gris-1 text-[16px]">{{
          'order_header.menu_selected_label' | translate
        }}</span>
        <div class="flex items-center gap-[10px]">
          <span class="fg-noir-2 text-[18px] font-semibold">{{
            currentMealPlan()!.admission_name
          }}</span>
          <div class="size-[5px] rounded-full bg-gris-2 shrink-0"></div>
          <span class="fg-vert-1 text-[18px] font-semibold">{{
            currentMealPlan()!.admission_price | formatPrice
          }}</span>
        </div>
      </div>

      <div class="w-px h-[47px] bg-gris-3"></div>
    }

    <div class="flex flex-col items-start">
      <span class="fg-gris-1 text-[16px]">{{ 'choose_order_type.name_label' | translate }}</span>
      <span class="fg-noir-2 text-[18px] font-semibold">
        @if (customer()?.firstname && customer()?.lastname) {
          {{ customer()!.firstname }} {{ customer()!.lastname }}
        } @else {
          {{ 'common.none' | translate }}
        }
      </span>
    </div>

    <div class="w-px h-[47px] bg-gris-3"></div>

    <div class="flex flex-col items-start">
      <span class="fg-gris-1 text-[16px]">{{ 'choose_order_type.status_label' | translate }}</span>
      <span class="fg-noir-2 text-[18px] font-semibold">{{
        userEnterpriseData()?.professional_social_category?.name || 'common.none' | translate
      }}</span>
    </div>

    <div class="w-px h-[47px] bg-gris-3"></div>

    <div class="flex flex-col items-start">
      <span class="fg-gris-1 text-[16px]">{{ 'choose_order_type.payment_label' | translate }}</span>
      <div class="flex items-center gap-[10px]">
        <span class="fg-noir-2 text-[18px] font-semibold">
          @if (paymentTypeKey()) {
            {{ paymentTypeKey() | translate }}
          } @else {
            {{ 'common.none' | translate }}
          }
        </span>
        @if (paymentTypeKey() == 'payment_type.wallet') {
          <div class="size-[5px] rounded-full bg-gris-2 shrink-0"></div>
          <span [class]="getBalanceColor()" class="text-[18px] font-semibold">
            @if (customer()?.wallet?.currency) {
              {{ customer()!.wallet!.currency / 100 | formatPrice }}
            } @else {
              {{ 0 | formatPrice }}
            }
          </span>
        }
      </div>
    </div>
  </div>

  <!-- Bouton Annuler -->
  <button
    type="button"
    (click)="cancel()"
    class="border border-gris-3 rounded-[5px] h-[58px] px-5 flex items-center gap-[10px] fg-noir-2 text-[16px] font-medium cursor-pointer hover:bg-gris-4 transition-colors"
  >
    {{ 'common.cancel' | translate }}
    <app-svg svgPath="assets/svg/close-circle.svg" width="20" height="20" />
  </button>
</div>

<div class="flex-1 min-h-0 overflow-hidden">
  <router-outlet></router-outlet>
</div>
